/**
 * Solid deep-space backdrop.
 *
 * Earlier passes painted cel bands or aurora ribbons here, but every
 * extra layer competed with the play action and made the dome read
 * "two-tone" rather than uniformly cosmic. Final answer: a single
 * solid near-black plane behind everything. The 3D starfield carries
 * all the cosmic sparkle on top.
 */

import {
  Color,
  DoubleSide,
  Mesh,
  MeshBasicMaterial,
  PlaneGeometry,
  type Object3D,
} from "three";

const BACKDROP_WIDTH = 320;
const BACKDROP_HEIGHT = 200;
const BACKDROP_Z = -95;
const BACKDROP_COLOR = 0x03040e;

export function createCosmicBackground(): Object3D {
  const geometry = new PlaneGeometry(BACKDROP_WIDTH, BACKDROP_HEIGHT);
  const material = new MeshBasicMaterial({
    color: new Color(BACKDROP_COLOR),
    side: DoubleSide,
    depthWrite: false,
    fog: false,
  });
  const mesh = new Mesh(geometry, material);
  mesh.name = "cosmic-background";
  mesh.position.set(0, 0, BACKDROP_Z);
  mesh.renderOrder = -10;
  return mesh;
}

export const __testing = {
  BACKDROP_WIDTH,
  BACKDROP_HEIGHT,
  BACKDROP_Z,
  BACKDROP_COLOR,
  // Legacy aliases retained for older test references.
  GRADIENT_HEIGHT: 1024,
  BACKGROUND_RADIUS: 200,
};
